
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"initials"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.453 17.5V3.223h1.66V17.5h-1.66zm16.748 0h-1.914L8.504 5.508h-.078l.068 1.094c.026.403.046.836.059 1.298.02.456.029.922.029 1.397V17.5H7.039V3.223h1.904l7.754 11.953h.069c-.013-.228-.03-.55-.05-.967l-.058-1.357c-.013-.489-.02-.941-.02-1.358V3.223h1.563V17.5z","fill":"currentColor"}})])
          )
        }
      }
    